import axios, { AxiosError } from 'axios';
import { getToken } from '@/lib/auth';
import {
  APIAccessDeniedError,
  APIAuthenticationError,
  APICommonError,
  APIError,
} from './error';

const instance = axios.create({
  baseURL: '/api',
  transformResponse: (data: string, _, status) => {
    if (status && status <= 400) {
      try {
        return JSON.parse(data);
      } catch {
        return null;
      }
    }
    return null;
  },
});

instance.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.TOKEN = token;
  }
  return config;
});

export async function post<T>(url: string, data?: unknown): Promise<T> {
  try {
    const resp = await instance.post<{
      code: number;
      message: string;
      data: T;
    }>(url, data);
    if (resp.data.code === 0) {
      return resp.data.data;
    }
    if (resp.data.code === -4) {
      throw new APIAccessDeniedError();
    }
    throw new APICommonError(resp.data.message);
  } catch (e) {
    if (e instanceof AxiosError) {
      if (e.response?.status === 403) {
        throw new APIAuthenticationError();
      }
      throw new APIError(-1, e.message, e);
    }
    if (e instanceof APIError) {
      throw e;
    }
    throw new APIError(-1, (e as Error).message || '未知错误', e);
  }
}
